module.exports = __webpack_public_path__ + "static/img/company_min.80d4fa89.svg";